import { render, staticRenderFns } from "./LeaveRequestWaiting.vue?vue&type=template&id=1b9c72da&scoped=true&"
import script from "./LeaveRequestWaiting.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestWaiting.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRequestWaiting.vue?vue&type=style&index=0&id=1b9c72da&prod&scoped=true&lang=css&"
import style1 from "./LeaveRequestWaiting.vue?vue&type=style&index=1&id=1b9c72da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c72da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VDivider,VIcon,VImg,VRow,VSpacer})
